"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = exports.OpenIcon = exports.Title = exports.Icon = exports.Head = exports.Item = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.976 3.976a.976.976 0 0 0-1.952 0v9.048H3.976a.976.976 0 1 0 0 1.952h9.048v9.048a.976.976 0 1 0 1.953 0v-9.048h9.047a.976.976 0 0 0 0-1.952h-9.048V3.976z"
  }));
};

PlusIcon.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};

var Item = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Item",
  componentId: "sc-6fm0a8-0"
})(function (_ref) {
  var color = _ref.theme.color,
      open = _ref.open;
  return {
    transition: '0.3s border',
    borderBottom: '1px solid',
    borderBottomColor: open ? color.brandPrimary.light : color.neutral['04']
  };
});

exports.Item = Item;

var Head = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Head",
  componentId: "sc-6fm0a8-1"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      color = _ref2$theme.color,
      spacing = _ref2$theme.spacing,
      open = _ref2.open;
  return {
    transition: '0.3s color',
    cursor: 'pointer',
    padding: "".concat(spacing.inline['3xs'], " 0"),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: open ? color.brandPrimary.light : color.neutral['02'],
    ':hover, :active': {
      color: color.brandPrimary.light
    }
  };
});

exports.Head = Head;

var Icon = _styledComponents["default"].span.withConfig({
  displayName: "Accordionstyle__Icon",
  componentId: "sc-6fm0a8-2"
})(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      color = _ref3$theme.color,
      spacing = _ref3$theme.spacing;
  return {
    fill: color.brandPrimary.light,
    marginRight: spacing.inline['3xs'],
    width: spacing.inline.xs,
    height: spacing.inline.xs,
    flex: "0 0 ".concat(spacing.inline.xs)
  };
});

exports.Icon = Icon;

var Title = _styledComponents["default"].p.withConfig({
  displayName: "Accordionstyle__Title",
  componentId: "sc-6fm0a8-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return _extends({}, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-md',
    margin: false
  }), {
    flex: 'auto',
    margin: 0
  });
});

exports.Title = Title;
var OpenIcon = (0, _styledComponents["default"])(PlusIcon).withConfig({
  displayName: "Accordionstyle__OpenIcon",
  componentId: "sc-6fm0a8-4"
})(function (_ref5) {
  var spacing = _ref5.theme.spacing,
      open = _ref5.open;
  return {
    transition: '0.3s transform',
    flex: '0 0 18px',
    width: 18,
    marginLeft: spacing.inline['4xs'],
    transform: "rotateZ(".concat(open ? '45deg' : '0deg', ")")
  };
});
exports.OpenIcon = OpenIcon;

var Body = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Body",
  componentId: "sc-6fm0a8-5"
})(function (_ref6) {
  var spacing = _ref6.theme.spacing,
      height = _ref6.height;
  return {
    transition: '0.4s height',
    padding: '0',
    height: height,
    overflow: 'hidden',
    ':after': {
      content: '""',
      height: spacing.inline['3xs'],
      display: 'block'
    }
  };
});

exports.Body = Body;